import React, { useEffect, useState } from 'react';
import { FlexBox, useAdvancedLockBodyScroll, HintTooltip } from '@brg/ui';
import { CloseIconWrapper, EditorContainer, EditorWrapper, EsseCounter, EsseHeader, EsseMain, EsseTitle, EsseWrapper, FullScreenButton, SaveButton, TextArea, ThemeBackground, } from './style';
import useLocalization from '../../../../../hooks/useLocalization';
import { HOME_WORK_TYPES } from './courseHomeWork';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-okaidia.css';
import CloseIcon from '../../../../icons/CloseIcon';
import ExpandIcon from '../../../../icons/ExpandIcon';
import { useSelector } from 'react-redux';
import { getCurrentFullscreen } from '../../../../../reducers/fullScreenReducer';
import { LineNumbers } from '../../../../Code/LineNumbers';
import { CodeStyles } from '../../../../Code/CodeStyles';
import { useModal } from '../../../../../core/modules/modal.module';
var TEXT_MAX_LENGTH = 1000;
var CODE_MAX_LENGTH = 100000;
export var CourseEssay = function (props) {
    var type = props.type, text = props.text, SaveHomeWork = props.SaveHomeWork, onEsseText = props.onEsseText, post = props.post, onClose = props.onClose;
    var t = useLocalization().t;
    var _a = useState(''), esseText = _a[0], setEsseText = _a[1];
    var isFullScreen = useSelector(function (state) { return getCurrentFullscreen(state, post === null || post === void 0 ? void 0 : post.postId); });
    var _b = useState(635), editorWidth = _b[0], setEditorWidth = _b[1];
    var _c = useAdvancedLockBodyScroll(), lockBody = _c[0], unlockBody = _c[1];
    var modal = useModal();
    var maxLength = type === HOME_WORK_TYPES.code ? CODE_MAX_LENGTH : TEXT_MAX_LENGTH;
    var defaultTitle = type === HOME_WORK_TYPES.code
        ? t('lms.homework.code_title')
        : t('lms.homework.text_title');
    var defaultPlaceholder = type === HOME_WORK_TYPES.code
        ? t('lms.homework.code_placeholder')
        : t('lms.homework.text_placeholder');
    var handleChange = function (e) {
        setEsseText(e.target.value);
        onEsseText(e.target.value);
    };
    var editorChange = function (code) {
        if (code.length <= CODE_MAX_LENGTH) {
            setEsseText(code);
            onEsseText(code);
        }
    };
    var handleToggleFullScreen = function () {
        modal.show('codeEditor', { code: esseText, onSubmit: editorChange });
    };
    useEffect(function () {
        isFullScreen ? lockBody() : unlockBody();
    }, [isFullScreen]);
    useEffect(function () {
        var lines = esseText.split('\n');
        var longestLineLength = Math.max.apply(Math, lines.map(function (line) { return line.length; }));
        var newWidth = longestLineLength * 12;
        if (newWidth > 600) {
            setEditorWidth(newWidth);
        }
    }, [esseText]);
    return (React.createElement(ThemeBackground, null,
        React.createElement(EsseWrapper, null,
            React.createElement(EsseHeader, { offsetBottom: 24, offsetBottomMobile: 16 },
                React.createElement(EsseTitle, null, text || defaultTitle),
                React.createElement(FlexBox, null,
                    type === HOME_WORK_TYPES.text && (React.createElement(EsseCounter, null,
                        esseText.length,
                        "/",
                        TEXT_MAX_LENGTH)),
                    onClose && (React.createElement(CloseIconWrapper, null,
                        React.createElement(HintTooltip, { z: 25, h: '32px', text: t('hint.close') || 'Закрыть', noArrow: true, noDisappearDelay: true },
                            React.createElement(CloseIcon, { onClick: onClose, style: {
                                    cursor: 'pointer',
                                    marginLeft: '16px',
                                    width: '20px',
                                    height: '20px'
                                } })))))),
            React.createElement(EsseMain, null,
                type === HOME_WORK_TYPES.code ? (React.createElement("div", { style: { position: "relative" } },
                    React.createElement(FullScreenButton, { isFullScreen: isFullScreen, onClick: handleToggleFullScreen },
                        React.createElement(ExpandIcon, null)),
                    React.createElement(EditorContainer, null,
                        React.createElement(EditorWrapper, { style: CodeStyles.editorWrapper, editorWidth: editorWidth, isFullScreen: isFullScreen },
                            React.createElement(LineNumbers, { text: esseText }),
                            React.createElement(Editor, { value: esseText, onValueChange: editorChange, highlight: function (code) { return highlight(code, languages.javascript); }, padding: 10, style: CodeStyles.editorBox }))))) : (React.createElement(TextArea, { placeholder: defaultPlaceholder, value: esseText, onChange: handleChange, maxLength: maxLength, className: 'mobile-textarea' })),
                React.createElement(SaveButton, { onClick: SaveHomeWork }, t('lms.homework.essay_btn'))))));
};
//# sourceMappingURL=courseEssay.js.mapimport React, { useEffect, useState } from 'react';
import { FlexBox, useAdvancedLockBodyScroll, HintTooltip } from '@brg/ui';
import { CloseIconWrapper, EditorContainer, EditorWrapper, EsseCounter, EsseHeader, EsseMain, EsseTitle, EsseWrapper, FullScreenButton, SaveButton, TextArea, ThemeBackground, } from './style';
import useLocalization from '../../../../../hooks/useLocalization';
import { HOME_WORK_TYPES } from './courseHomeWork';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-okaidia.css';
import CloseIcon from '../../../../icons/CloseIcon';
import ExpandIcon from '../../../../icons/ExpandIcon';
import { useSelector } from 'react-redux';
import { getCurrentFullscreen } from '../../../../../reducers/fullScreenReducer';
import { LineNumbers } from '../../../../Code/LineNumbers';
import { CodeStyles } from '../../../../Code/CodeStyles';
import { useModal } from '../../../../../core/modules/modal.module';
var TEXT_MAX_LENGTH = 1000;
var CODE_MAX_LENGTH = 100000;
export var CourseEssay = function (props) {
    var type = props.type, text = props.text, SaveHomeWork = props.SaveHomeWork, onEsseText = props.onEsseText, post = props.post, onClose = props.onClose;
    var t = useLocalization().t;
    var _a = useState(''), esseText = _a[0], setEsseText = _a[1];
    var isFullScreen = useSelector(function (state) { return getCurrentFullscreen(state, post === null || post === void 0 ? void 0 : post.postId); });
    var _b = useState(635), editorWidth = _b[0], setEditorWidth = _b[1];
    var _c = useAdvancedLockBodyScroll(), lockBody = _c[0], unlockBody = _c[1];
    var modal = useModal();
    var maxLength = type === HOME_WORK_TYPES.code ? CODE_MAX_LENGTH : TEXT_MAX_LENGTH;
    var defaultTitle = type === HOME_WORK_TYPES.code
        ? t('lms.homework.code_title')
        : t('lms.homework.text_title');
    var defaultPlaceholder = type === HOME_WORK_TYPES.code
        ? t('lms.homework.code_placeholder')
        : t('lms.homework.text_placeholder');
    var handleChange = function (e) {
        setEsseText(e.target.value);
        onEsseText(e.target.value);
    };
    var editorChange = function (code) {
        if (code.length <= CODE_MAX_LENGTH) {
            setEsseText(code);
            onEsseText(code);
        }
    };
    var handleToggleFullScreen = function () {
        modal.show('codeEditor', { code: esseText, onSubmit: editorChange });
    };
    useEffect(function () {
        isFullScreen ? lockBody() : unlockBody();
    }, [isFullScreen]);
    useEffect(function () {
        var lines = esseText.split('\n');
        var longestLineLength = Math.max.apply(Math, lines.map(function (line) { return line.length; }));
        var newWidth = longestLineLength * 12;
        if (newWidth > 600) {
            setEditorWidth(newWidth);
        }
    }, [esseText]);
    return (React.createElement(ThemeBackground, null,
        React.createElement(EsseWrapper, null,
            React.createElement(EsseHeader, { offsetBottom: 24, offsetBottomMobile: 16 },
                React.createElement(EsseTitle, null, text || defaultTitle),
                React.createElement(FlexBox, null,
                    type === HOME_WORK_TYPES.text && (React.createElement(EsseCounter, null,
                        esseText.length,
                        "/",
                        TEXT_MAX_LENGTH)),
                    onClose && (React.createElement(CloseIconWrapper, null,
                        React.createElement(HintTooltip, { z: 25, h: '32px', text: t('hint.close') || 'Закрыть', noArrow: true, noDisappearDelay: true },
                            React.createElement(CloseIcon, { onClick: onClose, style: {
                                    cursor: 'pointer',
                                    marginLeft: '16px',
                                    width: '20px',
                                    height: '20px'
                                } })))))),
            React.createElement(EsseMain, null,
                type === HOME_WORK_TYPES.code ? (React.createElement("div", { style: { position: "relative" } },
                    React.createElement(FullScreenButton, { isFullScreen: isFullScreen, onClick: handleToggleFullScreen },
                        React.createElement(ExpandIcon, null)),
                    React.createElement(EditorContainer, null,
                        React.createElement(EditorWrapper, { style: CodeStyles.editorWrapper, editorWidth: editorWidth, isFullScreen: isFullScreen },
                            React.createElement(LineNumbers, { text: esseText }),
                            React.createElement(Editor, { value: esseText, onValueChange: editorChange, highlight: function (code) { return highlight(code, languages.javascript); }, padding: 10, style: CodeStyles.editorBox }))))) : (React.createElement(TextArea, { placeholder: defaultPlaceholder, value: esseText, onChange: handleChange, maxLength: maxLength, className: 'mobile-textarea' })),
                React.createElement(SaveButton, { onClick: SaveHomeWork }, t('lms.homework.essay_btn'))))));
};
//# sourceMappingURL=courseEssay.js.map